module.exports = __webpack_public_path__ + "static/security-banner-b39948fe7b41aefe96bfa3025a30da93.svg";